import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TbAlertCircle, TbEyeglass, TbEyeglassOff } from 'react-icons/tb';

import { useTranslation } from '../../context/TranslationContext.jsx';

import {
  StatusBannerProgress,
  StatusBannerRoot,
  StatusBannerText,
  StatusIconContainer,
} from './styles';

const EyeTrackerStatusBanner = ({ status_code, message }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const { translate } = useTranslation();
  const isChecking = !status_code && !message;

  const getStatusColor = () => {
    if (isChecking) return theme.palette.info.main;
    if (status_code === 200) return theme.palette.primary.main;
    if (status_code === 503 || status_code === 504) return theme.palette.warning.main;
    return theme.palette.error.main;
  };

  const statusColor = getStatusColor();
  const iconSize = isLargeScreen ? 24 : 20;
  const displayMessage = isChecking
    ? translate('statusMessages.checkingEyeTracker')
    : message ||
      (status_code === 200
        ? translate('statusMessages.eyetrackerConnected')
        : status_code === 503 || status_code === 504
          ? translate('statusMessages.tryReplugging')
          : status_code >= 110 && status_code <= 114
            ? translate('statusMessages.eyeTrackerError')
            : translate('statusMessages.eyetrackerNotConnected'));

  const icon =
    status_code === 200 ? (
      <TbEyeglass size={iconSize} />
    ) : status_code === 503 || status_code === 504 ? (
      <TbAlertCircle size={iconSize} />
    ) : (
      <TbEyeglassOff size={iconSize} />
    );

  return (
    <StatusBannerRoot role="status" aria-live="polite" statusColor={statusColor}>
      <StatusIconContainer statusColor={statusColor}>{icon}</StatusIconContainer>
      <StatusBannerText component="span" statusColor={statusColor}>
        {displayMessage}
      </StatusBannerText>
      {isChecking ? (
        <StatusBannerProgress
          size={isLargeScreen ? 20 : 18}
          thickness={4}
          aria-label={translate('statusMessages.checkingEyeTracker')}
          statusColor={statusColor}
        />
      ) : null}
    </StatusBannerRoot>
  );
};

export default EyeTrackerStatusBanner;
